import { RpcBaseData } from '../rpc-base';

/**
 * RPC update data request name and version.
 */
export class RpcUpdateDataKey {
    public static command = 'UpdateData';
    public static version = '0.1.0';
}

/**
 * Rpc update data.
 */
export interface RpcUpdateData extends RpcBaseData {
    /**
     * Results data.
     */
    results: any;
}
